/* eslint-disable */
import { GeoElement } from "./geo-element.model";

export class GeoAddress {

    addressElements: GeoElement[] = [];

    public getLocality(): string | undefined {
        return this.getAddressComponent('locality');
    }

    public getSubLocality(): string | undefined {
        return this.getAddressComponent('sublocality');
    }

    public getAdminLevel1() {
        return this.getAddressComponent('administrative_area_level_1');
    }

    public getCountry(): string | undefined {
        return this.getAddressComponent('country');
    }

    private getAddressComponent(component: string): string | undefined {
        let componentElement: GeoElement | undefined = this.addressElements
            ?.filter(geoElement => geoElement.types
                ?.find(addressComponentType => addressComponentType === component)).pop();
        return componentElement?.name;
    }

    public getShortAddress(): string {
        let shortAddress = '';
        // sort addressElements based on sublocality, locality, administrative_area_level_1 and country
        this.addressElements.sort((a, b) => {
            const order = ['sublocality', 'locality', 'administrative_area_level_1', 'country'];
            let aIndex = -1;
            let bIndex = -1;

            for (const type of a.types || []) {
                const index = order.indexOf(type);
                if (index !== -1) {
                    aIndex = index;
                    break;
                }
            }

            for (const type of b.types || []) {
                const index = order.indexOf(type);
                if (index !== -1) {
                    bIndex = index;
                    break;
                }
            }
            return aIndex - bIndex;
        });
        this.addressElements.forEach(element => {
            if (element.types?.find(type => type === 'sublocality')) {
                shortAddress += element.name + ', ';
            } else if (element.types?.find(type => type === 'locality')) {
                shortAddress += element.name + ', ';
            } else  if (element.types?.find(type => type === 'administrative_area_level_1')) {
                shortAddress += element.name + ', ';
            } else if (element.types?.find(type => type === 'country')) {
                shortAddress += element.name;
            }
        });
        return shortAddress;
    }

    public getGeoAddressFromObject(addressObject: any) {
        // Create a new GeoAddress instance
        const geoAddress = new GeoAddress();

        // Convert the object's addressElements to GeoElement instances
        geoAddress.addressElements = addressObject.addressElements.map((addressElement: { types: string[] | undefined; name: string | undefined; }) => {
            const geoElement = new GeoElement();
            geoElement.types = addressElement.types;
            geoElement.name = addressElement.name;
            return geoElement;
        });

        return geoAddress;
    }
}

